import styles from "./label.module.css";

const ErrorLabel = ({ className = "", children }) => {
  return <p className={`${styles.errorLabel} ${className}`}>{children}</p>;
};

export default ErrorLabel;
